import React, { FunctionComponent, ReactNode } from "react";
import { ReactComponent as IconPlus } from "../../../../icons/plus.svg";
import { ReactComponent as IconCross } from "../../../../icons/x.svg";
import ConfirmModal from "../../ConfirmModal";
import "./style.scss";

interface Props {
  children: ReactNode;
  confirmLabel: string;
  dismissLabel: string;
  display: boolean;
  mode: "error" | "primary";
  onConfirm: () => void;
  onDismiss: () => void;
}
const ConfirmChangesModal: FunctionComponent<Props> = ({
  children,
  confirmLabel,
  dismissLabel,
  display,
  mode,
  onConfirm,
  onDismiss,
}) => {
  return (
    <ConfirmModal
      display={display}
      confirmLabel={confirmLabel}
      dismissLabel={dismissLabel}
      onConfirm={onConfirm}
      onDismiss={onDismiss}
      showCloseButton={false}
      validationButtonType={mode === "error" ? mode : "primary"}
    >
      <div className={`ConfirmChangesModal-top ConfirmChangesModal-top--${mode}`}>
        <span className="ConfirmChangesModal-top-icon">
          {mode === "error" && <IconCross />}
          {mode === "primary" && <IconPlus />}
        </span>
      </div>
      {children}
    </ConfirmModal>
  );
};

export default ConfirmChangesModal;
